<template>
    <v-sheet class="d-flex justify-center align-center flex-column" height="100vh">
        <v-progress-circular :size="50" color="red" indeterminate></v-progress-circular>
        <img src="@/assets/logo-big.svg" alt="Luzern" />
    </v-sheet>
</template>
<script setup lang="ts"></script>
